module.exports = __webpack_public_path__ + "img/CM-SS-25-Volkswagen-Lifestyle.78a16066.jpg";